import { action, observable, toJS } from 'mobx';
import {
  get as _get,
} from 'lodash';

export enum GoogleAdType {
  Sense = 'google-sense',
  Adx = 'google-adx',
}

export default class VivnAdStore {
  @observable public isVisible: boolean;
  @observable public startDate: string;
  @observable public endDate: string;
  @observable public adType: GoogleAdType;

  private root: any;

  constructor(root: any, initialState: IVivnAdStoreInitConfig) {
    this.root = root;
    this.isVisible = _get(initialState, 'isVisible', false);
    this.startDate = _get(initialState, 'startDate', getTodayDate());
    this.endDate = _get(initialState, 'endDate', getTodayDate());
    this.adType = _get(initialState, 'adType', GoogleAdType.Sense);
  }

  @action.bound
  public ssrInit(initialState: IVivnAdStoreInitConfig) {
    this.isVisible = _get(initialState, 'isVisible', false);
    this.startDate = _get(initialState, 'startDate', getTodayDate());
    this.endDate = _get(initialState, 'endDate', getTodayDate());
    this.adType = _get(initialState, 'adType', GoogleAdType.Sense);
  }

  @action.bound
  public toJson() {
    return {
      isVisible: this.isVisible,
      startDate: this.startDate,
      endDate: this.endDate,
      adType: this.adType,
    };
  }

}

export interface IVivnAdStoreInitConfig {
  isVisible: boolean;
  startDate?: string;
  endDate?: string;
  adType?: GoogleAdType;
}

export function getTodayDate(): string {
  const newDate: Date = new Date();
  const numMonth: number = newDate.getMonth() + 1;
  const numDate: number = newDate.getDate();
  const strMonth: string = (numMonth < 10) ? `0${numMonth}` : `${numMonth}`;
  const strDate: string = (numDate < 10) ? `0${numDate}` : `${numDate}`;
  return `${newDate.getFullYear()}/${strMonth}/${strDate}`;
}
